// LandPrepPopup.jsx

import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  IconButton,
  Grid,
  InputLabel,
  TextField,
  Select,
  MenuItem,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import DatePicker from "react-datepicker";
import CustomButton from "../../Custom/CustomButton";
import Divider from "@mui/material/Divider";
import AddIcon from "@mui/icons-material/Add";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { getAuth } from "../../../globals/authentication";
import axios from "axios";
import { useAlert } from "../../Alert";
import { SERVER_BASE_ADDRESS } from "../../../globals/const";
import { getFarmerPlotId } from "../../../globals/utils";
import instance from "../../../globals/axios";
import EditIcon from "../../../assets/svg/EditIcon.svg";
import RejectionPopup from "./RejectionPopup";
import SuccessPopup from "./SuccessPopup";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    top: theme.spacing(0.4),
    right: theme.spacing(1),
    fontSize: 16,
  },
  dialogContent: {
    height: 400,
  },
  datepicker: {
    display: "none",
  },
  taxtLabel: {
    fontSize: "12px !important",
    fontFamily: "Inter",
    fontWeight: "400 !important",
    color: "#000",
    marginTop: "10px",
  },
  taxtTitle: {
    fontSize: "12px !important",
    fontFamily: "Inter",
    fontWeight: "700 !important",
    color: "#000",
  },
  popup: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
  },
  popupContent: {
    backgroundColor: "#fff",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
  popupText: {
    marginLeft: theme.spacing(2),
  },
}));

const SeedTreatmentPopup = ({ onClose, t }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);
  const [images, setImages] = useState([]);
  const [fullImage, setFullImage] = useState(null);
  const [afterTreatmentImages, setAfterTreatmentImages] = useState([]);
  const [fullAfterTreatmentImage, setFullAfterTreatmentImage] = useState(null);
  const [existingData, setExistingData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const { showAlert } = useAlert();
  const [openRejectionPopup, setOpenRejectionPopup] = useState(false);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  let farmerPlotId = getFarmerPlotId();
  const [chemicalNames, setChemicalNames] = useState([]);
  const [units, setUnits] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(true);
  const roles = "FARMER";

  const scrollableContainerStyle = {
    maxHeight: "300px", // Adjust the height as needed
    overflowY: "auto",
  };
  const [formDataSet, setFormDataSet] = useState([
    {
      chemicalName: "",
      unit: "",
      dosePerAcre: "",
    },
  ]);
  const [selectedDateError, setSelectedDateError] = useState(false);
  const [chemicalErrors, setChemicalErrors] = useState(
    Array(formDataSet.length).fill(false)
  );

  useEffect(() => {
    const fetchChemicalNames = async () => {
      try {
        const response = await instance.get(
          "plotengagement/get-chemical-names?stage=SEED_TREATMENT"
        );
        setChemicalNames(response.data);
      } catch (error) {
        console.error("Error fetching chemical names:", error);
      }
    };

    const fetchUnits = async () => {
      try {
        const response = await instance.get(
          "plotengagement/get-units?stage=SEED_TREATMENT"
        );
        setUnits(response.data);
      } catch (error) {
        console.error("Error fetching units:", error);
      }
    };

    fetchChemicalNames();
    fetchUnits();
  }, []);
  const rows = [
    { label: "Chemical Name", type: "dropdown", key: "chemicalName" },
    { label: "Unit", type: "dropdown", key: "unit" },
    { label: "Dose per acre", type: "textfield", key: "dosePerAcre" },
  ];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await instance.get(
          `plotengagement/get-seed-treatment?farmer_plot=${farmerPlotId}`
        );
        let data = response.data;
        if (data.length > 0) {
          setExistingData(data[0]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (farmerPlotId) {
      fetchData();
    }
  }, [farmerPlotId]);

  useEffect(() => {
    if (existingData?.seed_treatment_date) {
      setSelectedDate(new Date(existingData.seed_treatment_date));
      let parsedChemicalDose = [];
      try {
        parsedChemicalDose = Array.isArray(existingData.chemical_dose)
          ? existingData.chemical_dose
          : JSON.parse(existingData.chemical_dose || "[]");
      } catch (error) {
        console.error("Error parsing chemical dose:", error);
      }

      const updatedFormData = parsedChemicalDose.map((dose) => ({
        chemicalName: dose.chemicalName || "",
        dosePerAcre: dose.dosePerAcre || "",
        unit: dose.unit || "",
      }));

      setComment(existingData.comments);
      setFormDataSet(updatedFormData || []);
      const beforeTreatmentImages =
        existingData.uploaded_files?.[0]?.before || [];
      const existingImageUrls = beforeTreatmentImages.map((image) => image.URL);
      const afterTreatmentImages =
        existingData.uploaded_files?.[0]?.after || [];
      const existingImageUrlsafter = afterTreatmentImages.map(
        (image) => image.URL
      );

      setImages(existingImageUrls);
      setAfterTreatmentImages(existingImageUrlsafter);
    }
  }, [existingData]);

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedDateError(false);
  };
  const handleChange = (field, index, value) => {
    setFormDataSet((prevData) => {
      const updatedFormData = [...prevData];
      const currentFormData = { ...updatedFormData[index] };
      if (field === "selectedChemical") {
        currentFormData[field] = value;
        currentFormData.chemicalDose = `${value} - ${
          currentFormData.selectedUnit
        } - ${currentFormData.chemicalDose || ""}`;
      } else {
        currentFormData[field] = value;
      }

      updatedFormData[index] = currentFormData;
      setChemicalErrors((prevErrors) => {
        const updatedErrors = [...prevErrors];
        updatedErrors[index] = false; // Set error to false for this index
        return updatedErrors;
      });
      return updatedFormData;
    });
  };
  const handleAddMore = () => {
    const newFormData = {
      chemicalName: "",
      unit: "",
      dosePerAcre: "",
    };
    setFormDataSet((prevData) => [...prevData, newFormData]);
  };
  const handleDeleteForm = (index) => {
    setFormDataSet((prevData) => {
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files).slice(0, 3 - images.length);
    const fileObjects = files.map((file) => URL.createObjectURL(file));
    setImages((prevImages) => [...prevImages, ...fileObjects]);
    const inputElement = document.getElementById("image-upload");
    if (inputElement) {
      inputElement.value = "";
    }
  };
  const handleImageClick = (image) => {
    setFullImage(image);
  };

  const handleCloseFullImage = () => {
    setFullImage(null);
  };
  const handleDeleteImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);
  };
  const handleAfterTreatmentImageUpload = (e) => {
    console.log("err");
    const files = Array.from(e.target.files).slice(
      0,
      3 - afterTreatmentImages.length
    );
    const fileObjects = files.map((file) => URL.createObjectURL(file));
    setAfterTreatmentImages((prevImages) => [...prevImages, ...fileObjects]);
    const inputElement = document.getElementById(
      "after-treatment-image-upload"
    );
    if (inputElement) {
      inputElement.value = "";
    }
  };
  const handleCloseAfterTreatmentFullImage = () => {
    setFullAfterTreatmentImage(null);
  };
  const handleAfterTreatmentImageClick = (image) => {
    setFullAfterTreatmentImage(image);
  };
  const handleDeleteAfterTreatmentImage = (index) => {
    const updatedAfterTreatmentImages = [...afterTreatmentImages];
    updatedAfterTreatmentImages.splice(index, 1);
    setAfterTreatmentImages(updatedAfterTreatmentImages);
  };

  const blobToFile = async (blobUrl, fileName) => {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return new File([blob], fileName, { type: blob.type });
  };

  const handleReject = (reason) => {
    const rejectionData = {
      id: existingData.id,
      stage: "seed_treatment",
      status: "REJECTED",
      reason_for_rejection: reason,
    };

    instance
      .post("plotengagement/ao-status-update", rejectionData)
      .then(() => {
        setOpenRejectionPopup(false);
        showAlert("success", "Data Rejected");
        setOpen(false);
        onClose();
      })
      .catch((error) => {
        console.error("Error rejecting data:", error);
      });
  };
  const handleApprove = () => {
    const approvalData = {
      id: existingData.id,
      stage: "seed_treatment",
      status: "APPROVED",
    };

    instance
      .post("plotengagement/ao-status-update", approvalData)
      .then(() => {
        showAlert("success", "Data Approved");
        setOpen(false);
        onClose();
      })
      .catch((error) => {
        console.error("Error approving data:", error);
      });
  };
  const validateForm = () => {
    const isDateValid = !!selectedDate;
    setSelectedDateError(!isDateValid);

    const hasChemicalErrors = formDataSet.some(
      (formData) =>
        !formData.chemicalName || !formData.unit || !formData.dosePerAcre
    );
    setChemicalErrors(
      formDataSet.map(
        (formData) =>
          !formData.chemicalName || !formData.unit || !formData.dosePerAcre
      )
    );

    const hasImageError = images.length === 0;

    return !(!isDateValid || hasChemicalErrors || hasImageError);
  };

  const handleSubmit = async () => {
    const isFormValid = validateForm();
    if (isFormValid) {
      setFormSubmitted(true);
      let token = getAuth().token;
      setLoading(true);
      const headers = {
        Authorization: `Token ${token}`,
        "Content-Type": "multipart/form-data",
      };

      const formData = new FormData();
      if (selectedDate) {
        const year = selectedDate.getFullYear();
        const month = `${selectedDate.getMonth() + 1}`.padStart(2, "0"); // Adding 1 as month is zero-based
        const day = `${selectedDate.getDate()}`.padStart(2, "0");
        formData.append("seed_treatment_date", `${year}-${month}-${day}`);
      } else {
        formData.append("seed_treatment_date", ""); // Placeholder for empty date
      }
      formData.append("comments", comment);

      if (!existingData) {
        const beforeTreatmentFiles = await Promise.all(
          images.map(async (blobUrl, index) => {
            return await blobToFile(
              blobUrl,
              `before_treatment_${index + 1}.png`
            );
          })
        );

        const afterTreatmentFiles = await Promise.all(
          afterTreatmentImages.map(async (blobUrl, index) => {
            return await blobToFile(
              blobUrl,
              `after_treatment_${index + 1}.png`
            );
          })
        );
        afterTreatmentFiles.forEach((file, index) => {
          formData.append(`after_treatment_img${index + 1}`, file);
        });
        beforeTreatmentFiles.forEach((file, index) => {
          formData.append(`before_treatment_img${index + 1}`, file);
        });
      }
      if (
        isEditMode &&
        (!existingData ||
          (existingData && existingData.uploaded_files[0].after.length === 0))
      ) {
        const afterTreatmentFiles = await Promise.all(
          afterTreatmentImages.map(async (blobUrl, index) => {
            return await blobToFile(
              blobUrl,
              `after_treatment_${index + 1}.png`
            );
          })
        );
        afterTreatmentFiles.forEach((file, index) => {
          formData.append(`after_treatment_img${index + 1}`, file);
        });
      }
      const chemicalDoseArray = [];
      formDataSet.forEach((formDataItem) => {
        const { chemicalName, unit, dosePerAcre } = formDataItem;
        if (chemicalName && unit && dosePerAcre) {
          const chemicalDose = {
            chemicalName,
            unit,
            dosePerAcre,
          };
          chemicalDoseArray.push(chemicalDose);
        }
      });
      formData.append("chemical_dose", JSON.stringify(chemicalDoseArray));
      if (isEditMode) {
        formData.append("id", existingData.id);
      } else {
        formData.append("farmer_plot", farmerPlotId);
      }
      if (existingData && existingData.status === "REJECTED") {
        formData.append("resubmit", true);
      }
      const apiUrl = isEditMode
        ? "plotengagement/update-seed-treatment"
        : "plotengagement/create-seed-treatment";

      axios
        .post(`${SERVER_BASE_ADDRESS}/${apiUrl}`, formData, {
          headers,
        })
        .then((res) => {
          if (res?.data) {
            setShowSuccessPopup(true);
            setTimeout(() => {
              setShowSuccessPopup(false);
              onClose();
            }, 2000);
          }
        })
        .catch((err) => {
          console.error("Error", err);
          setLoading(false);
          showAlert("error", "Some Error Occured");
        });
    } else {
      setFormSubmitted(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
    onClose();
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        style={{ zIndex: 1 }}
        PaperProps={{ style: { maxHeight: "calc(100% - 25%)" } }}
      >
        <div style={{ padding: "16px", height: "540px" }}>
          <Grid container>
            <Grid item xs={10}>
              <DialogTitle style={{ padding: "0px" }}>
                {t("Seed Treatment")}
              </DialogTitle>
            </Grid>
            {existingData !== null ? (
              <Grid item xs={1} style={{ marginTop: "10px" }}>
                <img src={EditIcon} onClick={handleEditClick} />
              </Grid>
            ) : null}
            <Grid item xs={1}>
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={7} style={{ marginTop: "20px" }}>
              <InputLabel style={{ fontSize: "12px" }}>
                {t("Date of seed treatment")}
              </InputLabel>
            </Grid>

            <Grid item xs={5}>
              <TextField
                fullWidth
                placeholder="DD/MM/YYYY"
                value={selectedDate ? selectedDate.toLocaleDateString() : ""}
                error={selectedDateError}
                helperText={selectedDateError ? "Please select date" : ""}
                disabled={!isEditMode && existingData !== null}
                InputProps={{
                  sx: {
                    height: "40px",
                    borderRadius: "5px", // You can adjust this if neededca
                    marginTop: "10px",
                    background: "#FFF",
                    border: "1px solid #C7BDBD",
                  },
                  readOnly: true,
                  onClick: () => document.getElementById("date-picker").click(),
                }}
              />
            </Grid>
            <DatePicker
              id="date-picker"
              dateFormat="dd/MM/yyyy"
              selected={selectedDate}
              onChange={handleDateChange}
              className={classes.datepicker}
            />
          </Grid>
          <div>
            <Typography className={classes.taxtTitle}>
              {t("Chemical Dose")}
            </Typography>
          </div>
          <div style={{ ...scrollableContainerStyle }}>
            {formDataSet.map((formData, formIndex) => (
              <div key={formIndex} style={{ padding: "0px" }}>
                {rows.map((row, index) => (
                  <Grid key={index} container style={{ marginTop: "10px" }}>
                    <Grid item xs={6}>
                      <InputLabel className={classes.taxtLabel}>
                        {t(row.label)}
                      </InputLabel>
                    </Grid>
                    <Grid item xs={6}>
                      {row.type === "dropdown" &&
                      row.key === "chemicalName" &&
                      chemicalNames ? (
                        <Select
                          value={formData[row.key]}
                          disabled={!isEditMode && existingData !== null}
                          error={chemicalErrors[formIndex]}
                          helperText={
                            chemicalErrors[formIndex]
                              ? "Please fill all fields"
                              : ""
                          }
                          onChange={(event) =>
                            handleChange(row.key, formIndex, event.target.value)
                          }
                          style={{ width: "100%" }}
                          sx={{
                            height: "40px",
                            border: "1px solid #9C9FA0",
                            borderRadius: "5px",
                          }}
                        >
                          {chemicalNames.map((option) => (
                            <MenuItem key={option.id} value={option.name}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : row.type === "dropdown" &&
                        row.key === "unit" &&
                        units ? (
                        <Select
                          value={formData[row.key]}
                          disabled={!isEditMode && existingData !== null}
                          error={chemicalErrors[formIndex]}
                          helperText={
                            chemicalErrors[formIndex]
                              ? "Please fill all fields"
                              : ""
                          }
                          onChange={(event) =>
                            handleChange(row.key, formIndex, event.target.value)
                          }
                          style={{ width: "100%" }}
                          sx={{
                            height: "40px",
                            border: "1px solid #9C9FA0",
                            borderRadius: "5px",
                          }}
                        >
                          {units.map((option) => (
                            <MenuItem key={option.id} value={option.name}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        <TextField
                          type={row.type === "textfield" ? "number" : "text"}
                          value={formData.dosePerAcre}
                          disabled={!isEditMode && existingData !== null}
                          error={chemicalErrors[formIndex]}
                          helperText={
                            chemicalErrors[formIndex]
                              ? "Please fill all fields"
                              : ""
                          }
                          onChange={(event) =>
                            handleChange(row.key, formIndex, event.target.value)
                          }
                          style={{ width: "100%" }}
                          size="small"
                          InputProps={{
                            sx: {
                              height: "40px",
                              borderRadius: "5px",
                              marginTop: "10px",
                              background: "#FFF",
                              border: "1px solid #C7BDBD",
                            },
                          }}
                        />
                      )}
                    </Grid>
                  </Grid>
                ))}

                {formIndex < formDataSet.length - 1 && (
                  <div>
                    <Divider style={{ margin: "10px 0" }} />
                    {isEditMode && existingData !== null ? (
                      <Grid container>
                        <Grid item xs={10}></Grid>
                        <Grid item xs={2}>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              handleDeleteForm(
                                !isEditMode ? formIndex + 1 : formIndex + 1
                              )
                            }
                          >
                            <CloseIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ) : existingData === null ? (
                      <Grid container>
                        <Grid item xs={10}></Grid>
                        <Grid item xs={2}>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              handleDeleteForm(
                                !isEditMode ? formIndex + 1 : formIndex + 1
                              )
                            }
                          >
                            <CloseIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ) : null}
                  </div>
                )}
              </div>
            ))}
          </div>

          <DialogActions style={{ display: "grid" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
                marginRight: "16px",
                width: "140px",
              }}
            >
              <Button
                onClick={handleAddMore}
                style={{
                  background:
                    !isEditMode && existingData !== null
                      ? "rgba(111, 163, 78, 0.5)"
                      : "#6FA34E",
                  border: "#538434",
                  borderRadius: "10px",
                  color: "#FFF",
                  textTransform: "none",
                }}
                disabled={!isEditMode && existingData !== null}
              >
                <AddIcon style={{ marginRight: "5px", fontSize: "15px" }} />{" "}
                {t("Add More")}
              </Button>
            </div>
          </DialogActions>

          {/* Modal for displaying full-size image */}
          <div>
            <Grid container>
              <Grid item xs={12}>
                <Typography style={{ fontWeight: 700 }}>
                  {t("Upload Image")}
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ marginTop: "10px" }}>
                {t("Before Treatment")}
                {!formSubmitted && images.length === 0 && (
                  <Typography
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginLeft: "10px",
                    }}
                  >
                    {t("Please select at least one image.")}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={2} style={{ marginTop: "10px" }}>
                {!existingData ? ( // Check if not in edit mode to allow functionality
                  <React.Fragment>
                    <input
                      type="file"
                      accept="image/jpeg, image/png"
                      onChange={handleImageUpload}
                      multiple
                      style={{ display: "none" }}
                      id="image-upload"
                    />
                    <label htmlFor="image-upload">
                      <CameraAltIcon />
                    </label>
                  </React.Fragment>
                ) : null}
              </Grid>
            </Grid>
          </div>

          <Grid container spacing={2} style={{ marginTop: "20px" }}>
            {images.map((image, index) => (
              <Grid key={index} item xs={4}>
                <div style={{ position: "relative" }}>
                  {!existingData ? ( // Check if in edit mode to disable functionality
                    <IconButton
                      aria-label="close"
                      onClick={() => handleDeleteImage(index)}
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        zIndex: 1,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  ) : null}
                  <img
                    src={image}
                    alt={`Before Treatment Preview ${index}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: isEditMode ? "default" : "pointer", // Disable cursor if in edit mode
                    }}
                    onClick={
                      !isEditMode
                        ? undefined
                        : !existingData
                        ? () => handleImageClick(image)
                        : () => handleImageClick(image)
                    } // Disable onClick event if in edit mode
                  />
                </div>
              </Grid>
            ))}
          </Grid>

          {/* Modal for displaying full-size image */}
          <Dialog
            open={Boolean(fullImage)}
            onClose={handleCloseFullImage}
            maxWidth="lg"
          >
            <Grid container justifyContent="flex-end">
              <IconButton
                aria-label="close"
                onClick={handleCloseFullImage}
                style={{ position: "absolute", top: 0, right: 0 }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <img
              src={fullImage}
              alt="Before Treatment Full Size"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                margin: "auto",
                display: "block",
              }}
            />
          </Dialog>

          {/* After Treatment Images Section */}
          <div>
            <Grid container>
              <Grid item xs={6} style={{ marginTop: "10px" }}>
                {t("After Treatment")}
              </Grid>
              <Grid item xs={2} style={{ marginTop: "10px" }}>
                {isEditMode &&
                (!existingData ||
                  (existingData &&
                    existingData.uploaded_files[0].after.length === 0)) ? (
                  <React.Fragment>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleAfterTreatmentImageUpload}
                      multiple
                      style={{ display: "none" }}
                      id="after-treatment-image-upload"
                    />
                    <label htmlFor="after-treatment-image-upload">
                      <CameraAltIcon />
                    </label>
                  </React.Fragment>
                ) : !isEditMode && !existingData ? (
                  <React.Fragment>
                    <input
                      type="file"
                      accept="image/jpeg, image/png"
                      onChange={handleAfterTreatmentImageUpload}
                      multiple
                      style={{ display: "none" }}
                      id="after-treatment-image-upload"
                    />
                    <label htmlFor="after-treatment-image-upload">
                      <CameraAltIcon />
                    </label>
                  </React.Fragment>
                ) : null}
              </Grid>
            </Grid>
          </div>

          <Grid container spacing={2} style={{ marginTop: "20px" }}>
            {afterTreatmentImages.map((image, index) => (
              <Grid key={index} item xs={4}>
                <div style={{ position: "relative" }}>
                  {existingData ? null : ( // Check if in edit mode to disable functionality
                    <IconButton
                      aria-label="close"
                      onClick={() => handleDeleteAfterTreatmentImage(index)}
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        zIndex: 1,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                  <img
                    src={image}
                    alt={`After Treatment Preview ${index}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: isEditMode ? "default" : "pointer", // Disable cursor if in edit mode
                    }}
                    onClick={
                      existingData
                        ? undefined
                        : () => handleAfterTreatmentImageClick(image)
                    } // Disable onClick event if in edit mode
                  />
                </div>
              </Grid>
            ))}
          </Grid>

          {/* Modal for displaying full-size after treatment image */}
          <Dialog
            open={Boolean(fullAfterTreatmentImage)}
            onClose={handleCloseAfterTreatmentFullImage}
            maxWidth="lg"
          >
            <Grid container justifyContent="flex-end">
              <IconButton
                aria-label="close"
                onClick={handleCloseAfterTreatmentFullImage}
                style={{ position: "absolute", top: 0, right: 0 }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <img
              src={fullAfterTreatmentImage}
              alt="After Treatment Full Size"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                margin: "auto",
                display: "block",
              }}
            />
          </Dialog>
          <div style={{ display: "grid", padding: "10px" }}>
            <InputLabel>{t("Comment(Optional)")}</InputLabel>
            <TextField
              multiline
              rows={1}
              value={comment}
              disabled={!isEditMode && existingData !== null}
              onChange={handleCommentChange}
            />
            {existingData &&
              existingData.status === "REJECTED" &&
              existingData.reason_for_rejection &&
              !isEditMode &&
              roles === "FARMER" && (
                <Typography style={{ marginTop: "10px", color: "red" }}>
                  {t("Reason for Rejection")}:{" "}
                  {existingData.reason_for_rejection}
                </Typography>
              )}
          </div>
          <div
            style={{
              display: "flex",
              margin: "auto",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                margin: "auto",
                justifyContent: "center",
              }}
            >
              {existingData && isEditMode ? (
                <div style={{ width: "140px" }}>
                  <CustomButton onClick={handleSubmit} hideIcon>
                    {t("Update")}
                  </CustomButton>
                </div>
              ) : !existingData && !isEditMode ? (
                <div
                  style={{
                    display: "flex",
                    margin: "auto",
                    justifyContent: "center",
                    width: "140px",
                  }}
                >
                  <CustomButton onClick={handleSubmit} hideIcon>
                    {t("Submit")}
                  </CustomButton>
                </div>
              ) : null}
            </div>
          </div>
          {existingData &&
          existingData.status === "PENDING" &&
          !isEditMode &&
          (roles === "AO" || roles === "SPVR") ? (
            <div
              style={{
                display: "flex",
                width: "150px",
                margin: "auto",
                justifyContent: "center",
              }}
            >
              <CustomButton
                buttonText={t("Reject")}
                handleOnChange={() => setOpenRejectionPopup(true)}
                hideIcon
              />
              <div style={{ marginLeft: "10px" }}></div>
              <CustomButton
                buttonText={t("Approve")}
                handleOnChange={handleApprove}
                hideIcon
              />
            </div>
          ) : null}
        </div>
        {loading && (
          <div className={classes.popup}>
            <div className={classes.popupContent}>
              <CircularProgress size={24} />
              <Typography variant="body1" className={classes.popupText}>
                {t("Submitting")}...
              </Typography>
            </div>
          </div>
        )}
        <RejectionPopup
          open={openRejectionPopup}
          handleClose={() => setOpenRejectionPopup(false)}
          handleSubmit={handleReject}
        />
        {showSuccessPopup && (
          <SuccessPopup onClose={() => setShowSuccessPopup(false)} />
        )}
      </Dialog>
    </div>
  );
};

export default SeedTreatmentPopup;
